/**
 * Concept titles are stored with the KLine-md convention: target-language
 * words wrapped in *asterisks*. The CM TextEditor works with <target> tags,
 * so titles are converted on the way in and out of the editor.
 */

export const mdTitleToHtml = (md: string): string => md.replace(/\*([^*]+)\*/g, '<target>$1</target>');

export const htmlTitleToMd = (html: string): string => {
  let text = html.replace(/<\/?p[^>]*>/gi, ' ').replace(/<br\s*\/?>/gi, ' ');
  text = text.replace(/<target[^>]*>/gi, '*').replace(/<\/target>/gi, '*');
  const div = document.createElement('div');
  div.innerHTML = text;
  return (div.textContent ?? '')
    .replace(/ /g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};
